import { z } from 'zod';
import { ValidationEntrySeveritySchema } from '../../../../../react-commons/components/ValidationEntrySeverity';
import { msObject } from '../../resource-base/msObject';
import { ArtifactsCreatedStatisticsSchema } from '../../services/backgroundTaskResource';
import { MutationValidationResourceSchema } from './mutationValidationResource';

export const PersistableCreationResultSetSchema = msObject({
    successful: z.boolean(),
    maxSeverity: ValidationEntrySeveritySchema.nullable(),
    erroneousCreationResult: MutationValidationResourceSchema.nullable(),
    numberOfArtifactsCreated: z.number(),
    artifactsCreatedCountMap: z.record(z.string(), ArtifactsCreatedStatisticsSchema),
    persistableCreationResults: z.record(z.string(), MutationValidationResourceSchema.array()).optional(),
});

export type PersistableCreationResultSet = z.infer<typeof PersistableCreationResultSetSchema>;
